import React from 'react'
import { Upload } from "@progress/kendo-react-upload";

export default function UiFileUpload(props) {
    const onCancel = (e) =>{
        console.log(e)
    }
    const onSaveRequest = (files) =>{
        // console.log(files[0]);  
    }
    const onRemoveRequest = (files) =>{
        // console.log(files[0]);  
    }

 
    return (
        <>
            <Upload
                autoUpload={false}
                defaultFiles={[]}
                withCredentials={false}
                onCancel={onCancel}
                // saveUrl={onSaveRequest}
                // removeUrl={onRemoveRequest}
                saveUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/save"}
                removeUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/remove"}
            />
        </>
    )
}
